<template>
  <div class="app">
    <div ref="resizeContainer" v-resize="handleResize">
      <AppHeader fixed>
        <SidebarToggler class="d-lg-none" display="md" mobile />
        <b-link class="navbar-brand" to="#">
          <img class="navbar-brand-full" src="../../assets/images/boletoflex-logo.png" height="25" alt="BoletoFlex Logo">
          <img class="navbar-brand-minimized" src="../../assets/images/boletoflex-logo-min.png" height="30" alt="BoletoFlex Logo">
        </b-link>
        <SidebarToggler class="d-md-down-none" display="lg" />
        <b-navbar-nav class="d-md-down-none">
          <!--<b-nav-item class="px-3" to="/dashboard">Dashboard</b-nav-item>-->
          <!--<b-nav-item class="px-3" to="/users" exact>Users</b-nav-item>-->
          <!--<b-nav-item class="px-3">Settings</b-nav-item>-->
        </b-navbar-nav>
        <b-navbar-nav class="ml-auto" style="padding-right: 10px">
          <!--<b-nav-item class="d-md-down-none">-->
            <!--<i class="icon-bell"></i>-->
            <!--<b-badge pill variant="danger">5</b-badge>-->
          <!--</b-nav-item>-->
          <!--<b-nav-item class="d-md-down-none">-->
            <!--<i class="icon-list"></i>-->
          <!--</b-nav-item>-->
          <!--<b-nav-item class="d-md-down-none">-->
            <!--<i class="icon-location-pin"></i>-->
          <!--</b-nav-item>-->
          <DefaultHeaderDropdownAccnt/>
        </b-navbar-nav>
        <AsideToggler class="d-none d-lg-block" />
        <AsideToggler class="d-lg-none" mobile />
      </AppHeader>
      <div class="app-body">
        <AppSidebar fixed>
          <SidebarHeader/>
          <SidebarForm/>
          <SidebarNav v-if="$auth.check('ROLE_ADMIN') || $auth.check('ROLE_SUPER')" :navItems="nav"></SidebarNav>
          <SidebarNav v-else-if="$auth.check('ROLE_ADMIN_VIEW')" :navItems="navView"></SidebarNav>
          <SidebarFooter/>
          <SidebarMinimizer/>
        </AppSidebar>
        <main class="main" style="background-color: #FAFAFA">
          <Breadcrumb :list="list"/>
          <div class="container-fluid">
            <router-view></router-view>
          </div>
        </main>
        <AppAside fixed>
          <!--aside-->
          <DefaultAside/>
        </AppAside>
      </div>
    </div>
  </div>
</template>

<script>
import nav from '@/_nav'
import navView from '@/_navView'
import { Header as AppHeader, SidebarToggler, Sidebar as AppSidebar, SidebarFooter, SidebarForm, SidebarHeader, SidebarMinimizer, SidebarNav, Aside as AppAside, AsideToggler, Footer as TheFooter, Breadcrumb } from '@coreui/vue'
import DefaultAside from './DefaultAside'
import DefaultHeaderDropdownAccnt from './DefaultHeaderDropdownAccnt'
import resize from 'vue-resize-directive'

export default {
  directives: {
    resize
  },
  name: 'DefaultContainer',
  components: {
    AsideToggler,
    AppHeader,
    AppSidebar,
    AppAside,
    TheFooter,
    Breadcrumb,
    DefaultAside,
    DefaultHeaderDropdownAccnt,
    SidebarForm,
    SidebarFooter,
    SidebarToggler,
    SidebarHeader,
    SidebarNav,
    SidebarMinimizer
  },
  data () {
    return {
      nav: nav.items,
      navView: navView.items,
      total: null,
      interval: null,
      isSideBarMinimized: false
    }
  },
  computed: {
    name () {
      return this.$route.name
    },
    list () {
      return this.$route.matched.filter((route) => route.name || route.meta.label)
    }
  },
  mounted () {
    this.$auth.refresh({
      params: {},
      success: function (res) {
        this.$auth.user(res.data)
        if (this.interval) {
          clearInterval(this.interval)
        }
        this.interval = setInterval(() => {
          this.totalValidations()
        }, 60000)
      },
      error: function (res) {
        console.log('error ' + res.status)
        if (res.status === 401) {
          clearInterval(this.interval)
          this.$auth.logout({
            makeRequest: false,
            success () {
              console.log('success ' + this.context)
              this.$router.replace('/pages/login')
            },
            error () {
              console.log('error ' + this.context)
            }
          })
        }
      }
    })
    this.totalValidations()
  },
  methods: {
    totalValidations () {
      this.$http.get('api/dashboard/validations/total')
        .then(function (res) {
          var total = res.data.total
          this.total = nav.items[9].badge.text = `${total.toString()}`
          // this.nav = [...nav.items, this.total]
        })
        .catch(function (res) {
          console.log('Error')
          console.log(res)
        })
    },
    handleResize () {
      var body = document.body

      if (this.$refs.resizeContainer.clientWidth <= 1366) {
        if (!this.isSideBarMinimized) {
          body.classList.add('sidebar-minimized')
          body.classList.add('brand-minimized')
        }

        this.isSideBarMinimized = true
      } else {
        body.classList.remove('sidebar-minimized')
        body.classList.remove('brand-minimized')

        this.isSideBarMinimized = false
      }
    }
  },
  beforeDestroy: function () {
    clearInterval(this.interval)
  }
}
</script>
<style lang="css" scope>
.app-header {
  padding: 0!important;
}
</style>



// WEBPACK FOOTER //
// src/components/containers/DefaultContainer.vue